/** Session cache: raw cvrapi.dk JSON (incl. error payloads), keyed by 8-digit CVR. */
const cvrRawCache = new Map();

const UA = "YourFairShare - cps@azilis.dk";

/**
 * Raw cvrapi.dk response (may include `error`, `enddate`, etc.). Cached per session.
 * @param {string} cvr — digits only, 8 chars for DK
 * @returns {Promise<object|null>} `null` if not 8 digits or network failure
 */
export async function fetchCvrDenmarkRaw(cvr) {
  const key = String(cvr || "").replace(/\s/g, "");
  if (!/^\d{8}$/.test(key)) return null;
  if (cvrRawCache.has(key)) return cvrRawCache.get(key);
  try {
    const res = await fetch(
      `https://cvrapi.dk/api?search=${encodeURIComponent(key)}&country=dk`,
      {
        headers: { "User-Agent": UA },
      }
    );
    const data = await res.json().catch(() => null);
    if (data && typeof data === "object") cvrRawCache.set(key, data);
    return data && typeof data === "object" ? data : null;
  } catch {
    return null;
  }
}

/**
 * @param {string} cvr — digits only, typically 8 chars for DK
 * @returns {Promise<object|null>}
 */
export async function fetchCompanyByCVR(cvr) {
  const data = await fetchCvrDenmarkRaw(cvr);
  if (!data || data.error) return null;
  return data;
}

/**
 * Map cvrapi.dk payload → form-friendly fields (Danish labels where relevant).
 * @param {object} cvr
 */
export function mapCVRToFacilityFields(cvr) {
  if (!cvr || typeof cvr !== "object") return {};
  return {
    vat: cvr.vat != null ? String(cvr.vat) : "",
    name: cvr.name || "",
    street: cvr.address || "",
    postal_code: cvr.zipcode != null ? String(cvr.zipcode) : "",
    city: cvr.city || "",
    country: "Danmark",
    fte_suggested:
      cvr.employees != null && !Number.isNaN(Number(cvr.employees))
        ? String(cvr.employees)
        : "",
    enddate: cvr.enddate || null,
  };
}
